import { compress, decompress } from 'lz-string';

export const compressData = (data: any): string => {
  return compress(JSON.stringify(data));
};

export const decompressData = (compressedData: string): any => {
  return JSON.parse(decompress(compressedData));
};
